import React, {createRef, Fragment, useEffect, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { Grid, makeStyles } from "@material-ui/core";

import {MaskedText, DatePicker, FormDialog, ComboSelect, AircraftMultiSelect, FormSelect, Text} from "../../../../controls";
import ScheduledTripLegEditor from "./ScheduledTripLegEditor";
import BuildPrimaryRouteFromLegs from '../../utils/BuildPrimaryRouteFromLegs';
import BuildOnwardRoutesFromLegs from '../../utils/BuildOnwardRoutesFromLegs';
import BuildTruckRoutesFromLegs from '../../utils/BuildTruckRoutesFromLegs';
import Validator from "../../validators/EditScheduledTripValidator";
import {useQueryClient} from "react-query";
import useTripDepartmentUsers from "../../../../services/auth/useTripDepartmentUsers";
import { fetch as fetchCostingFuelRate } from '../../../../services/costings/useCostingFuelRate';
import { getCostingByUcn, getCostingDefaultValues } from '../../../Costings/includes/costingDialogFunctions';
import AddCostingDialog from '../../../Costings/components/AddCostingDialog';
import EditCostingDialog from '../../../Costings/components/EditCostingDialog';
import ViewCostingDialog from '../../../Costings/components/ViewCostingDialog';
import ContextMenu from '../../../../controls/ContextMenu';
import { MonetizationOn } from '@material-ui/icons';
import { Preview } from '@mui/icons-material';
import CostingsStyles from '../../../Costings/styles/CostingsStyles';
import { useAddCosting, useUpdateCosting } from '../../../../services/costings';
import { useScheduledTripClients } from '../../../../services/scheduledTrips';


const EditScheduledTripDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const apiSitePrefix = props.apiSitePrefix;
  const extraKeys = props.extraKeys;
  const handleUpdate = props.handleUpdate;
  const formatChars = props.formatChars;
  const classes = props.classes;
  const tripOwnerDepartment = props.ownerDepartment;

  const eventBus = SystemData.eventBus;

  const costingClasses = makeStyles(CostingsStyles)();

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    parentRecord: null,
    childRecords: null,
    title: 'Edit Scheduled Trip',
    originalRecord: null
  });

  const emptyCosting = {
    costingDate: moment.utc().toISOString(),
    routeWinds: process.env.REACT_APP_DEFAULT_WINDCODE || 'GRIB-UKO-WX',
    routeWindsMonth: "",
    legs:[],
    cargo: [],
    services: [],
    weightUom: "KG",
    contingencyFuelCostRate:0,
    contingencyBlockHoursRate:0,  
  }

  const minDate = dialogStates.parentRecord && dialogStates.parentRecord.length > 0?moment.utc(dialogStates.parentRecord[0].startDate):moment.utc().add(1, 'day');
  const maxDate = dialogStates.parentRecord && dialogStates.parentRecord.length > 0?moment.utc(dialogStates.parentRecord[0].endDate):moment.utc().add(3, 'year');
  const initialDate = minDate.toISOString();
  const dateFormat = "DD/MM/YYYY";

  const queryClient = useQueryClient();
  const departmentUsers = useTripDepartmentUsers({queryClient, extraKeys: [tripOwnerDepartment]});

  const handleAddCosting = useAddCosting();
  const handleUpdateCosting = useUpdateCosting();

  const [costingDefaultValues, setCostingDefaultValues] = useState({});
  const [legsChanged, setLegsChanged] = useState(false);

  useEffect(()=> {
    const open = async (params) => {
      const {rowData: _record, parentRow: parentRecord, childRows: childRecords, title} = params;
      const legs = (_record?.legs||[]).map(leg => {return {alternateAirportCode: null, alternateIcaoCode: null, ...leg}});
      const record = _record?{...(__.cloneDeep(_record)), legs}:_record;
      setDialogStates({...dialogStates, showDialog:true, record, parentRecord, childRecords, title, originalRecord: __.cloneDeep(record)});
      setLegsChanged(false);
    }

    eventBus.bind("EditScheduledTripDialog.open", open);

    return () => {
      eventBus.unbind("EditScheduledTripDialog.open", open);
    }
  }, [dialogStates, eventBus, extraKeys]);

  if (!costingDefaultValues || __.isEmpty(costingDefaultValues)) {
    getCostingDefaultValues(apiSitePrefix, SystemData, setCostingDefaultValues);
  }

  // const open = (_record, parentRecord, childRecords, title) => {
  //   const legs = (_record?.legs||[]).map(leg => {return {alternateAirportCode: null, alternateIcaoCode: null, ...leg}});
  //   const record = _record?{...(__.cloneDeep(_record)), legs}:_record;
  //   setDialogStates({...dialogStates, showDialog:true, record, parentRecord, childRecords, title});
  // }
  // const close = () => {
  //   setDialogStates({...dialogStates, showDialog:false, record: {}, parentRecord:null, childRecords:null, title: 'Edit Scheduled Trip'});
  // }

  const userOptions = departmentUsers.data?departmentUsers.data.map((userOption, i) => {
    return {code: userOption.user_id, value: `${userOption.firstName} ${userOption.lastName}`};
  }).sort((u1, u2) => {
    if (u1.value === u2.value) return 0;
    if (u1.value < u2.value) return -1;
    return 1;
  }):null;

  const tripClients = useScheduledTripClients({queryClient, extraKeys: [dialogStates?.record?.scheduledTripUuid||'UNKNOWN']});

  const handleAddSector = () => {
    if (eventBus) {
      eventBus.trigger('ScheduledTrip.AddSector');
    }
  }

  const checkForChanges = (record) => {
    const {originalRecord} = dialogStates;
    if (legsChanged) return true;

    const fieldsToCompare = ['tripDate', 'commercialOwnerId', 'uniqueCostingNo'];
    for (let i = 0; i < fieldsToCompare.length; i++) {
      const fieldName = fieldsToCompare[i];
      if (record[fieldName] !== originalRecord[fieldName]) return true;
    }

    return false;
  }

  const generateCosting = async (record) => {
    const recordChanged = checkForChanges(record);

    if (recordChanged) {
      SystemData.alert("error", "Please save all changes before Generating a Costing");
      return;
    }

    const cargo = [];
    const legs = []; 

    let costingAircraftReg = (record.initialAircraft && record.initialAircraft.length > 0 && record.initialAircraft[0]) || (record.aircraftRotation && record.aircraftRotation.length > 0 && record.aircraftRotation[0]) || '';
  
    if (tripClients && Array.isArray(tripClients.data)) {
      for (let i = 0; i < tripClients.data.length; i++) {
        const costingCargoUuid = uuidv4();
        const {origin: originAirportCode, destination: destinationAirportCode, companyName, companyUuid, allotmentKg: payloadLoose} = tripClients.data[i];
        const consignment = {costingCargoUuid, originAirportCode, destinationAirportCode, companyName, companyUuid, payloadLoose, payloadUnitised: 0, bupCount: 0, includeHandling: true, cargoSecure: true};

        cargo.push(consignment);
      }
    }

    if (record && Array.isArray(record.legs)) {
      for (let i = 0; i < record.legs.length; i++) {     
        const costingSectorUuid = uuidv4();
        const {originAirportCode, destinationAirportCode, alternateAirportCode, transportType, legType } = record.legs[i]; 
        const {costingDate} = record;

        const fuelRecord = await fetchCostingFuelRate({queryClient, extraKeys:[originAirportCode, costingDate], useCache: true});
        let originFuelRecord = {success: false, error: fuelRecord.error};
        let fuelPrice = null;
        if (fuelRecord && fuelRecord.success && fuelRecord.rateRecord) {
          const {rate} = fuelRecord.rateRecord;
          fuelPrice = rate;
          originFuelRecord = {...fuelRecord.rateRecord, success: true};
        }
        
        const leg = {
          costingSectorUuid, 
          orderSequence: i, 
          originAirportCode, 
          destinationAirportCode, 
          alternateAirportCode, 
          transportType, 
          legType, 
          aircraftReg: costingAircraftReg, 
          flightJetPlanUuid: null,
          fuelPolicyType: "",
          planData: null, 
          fuelPrice,   
          originFuelRecord,       
          revenueCalculationMethod: "COST PLUS" , 
          revenueCalculationAmount: 0
        };
        legs.push(leg);
      }  
    }

    if (!__.isNil(costingDefaultValues?.contingencyFuelCostRate)) emptyCosting['contingencyFuelCostRate'] = costingDefaultValues.contingencyFuelCostRate;
    if (!__.isNil(costingDefaultValues?.contingencyBlockHoursRate)) emptyCosting['contingencyBlockHoursRate'] = costingDefaultValues.contingencyBlockHoursRate;
  
    const newCostingRecord = {
      ...emptyCosting,
      // enquiryUuid: record.enquiryUuid,
      tripUuid: record.scheduledTripOverrideUuid || record.scheduledTripUuid,
      commercialOwnerId: record.commercialOwnerId,
      revenueCalculationMethod: "COST PLUS",
      cargo,
      legs,
      aircraftReg: costingAircraftReg
    }
    eventBus.trigger('AddCostingDialog.open', newCostingRecord);
  }

  const viewCosting = async (record) => {
    if (record.uniqueCostingNo) {
      const costingRecord = await getCostingByUcn(record.uniqueCostingNo, apiSitePrefix, SystemData);
      if (costingRecord) {
        eventBus.trigger("ViewCostingDialog.open", costingRecord);
      }
    }
  }

  const editCosting = async (record) => {
    if (record.uniqueCostingNo) {
      const costingRecord = await getCostingByUcn(record.uniqueCostingNo, apiSitePrefix, SystemData);
      if (costingRecord) {
        eventBus.trigger("EditCostingDialog.open", costingRecord);
      }
    }
  }
  
  const handleGenerateCosting = (record) => {
    generateCosting(record);
  }

  const handleLegsChanged = (changes, props) => {
    const {record, recordChange} = props;
    if (changes && changes.record) {
      const legs = changes.record.legs;
      record['legs'] = legs;
      recordChange({...record, legs});

      if (changes.resolve) {
        changes.resolve();
      }
    }
  }

  const checkCascade = (record, callBack) => {
    if (!dialogStates.childRecords || dialogStates?.childRecords?.length <= 0) {
      callBack({...record, cascade: false});
    } else {
      SystemData.confirm(
        "Cascade Changes",
        `Do you wish to cascade the changes to the Overrides`,
        [
          {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
          {icon: "cancel", value: false, label: "No", options: {color:"primary"}}
        ],
        (response) => {
          callBack({...record, cascade: response});
        }
      );
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{maxWidth: "lg", fullWidth: true}}
        classes={classes}
        validator={Validator}
        buttons = {{
          generateCosting: {icon: "monetization_on", key: "Generate Costing", label: "Generate Costing", color: "primary", disabled: (status)=>{
            console.log(status);
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error;
          }},
          addSector: {icon: "add_circle", key: "Add Sector", label: "Add Sector", color: "primary"},
          save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            const legs = record.legs.map((leg) => __.omit(leg, ['servicesChanged']));
            record['legs'] = legs;
            checkCascade(record, (record)=> {
              handleUpdate.mutate({
                extraKeys,
                record,
                postSuccess: () => {
                  setDialogStates({...dialogStates, showDialog: false, record: null})
                },
                postError: (data) => {
                  if (data.errorMessage) {
                    SystemData.alert("Error", `${data.errorMessage}`);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred.`);
                  }
                }
              });
            })
          } else if (state.buttonPressed === "generateCosting") {
            const record = state.record;
            handleGenerateCosting(record);
          } else if (state.buttonPressed === "addSector") {
            handleAddSector();
          } else {

            setDialogStates({...dialogStates, showDialog: false, record: null});
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
        <Grid item xs={2} checkChildren={true}>
            <DatePicker
              id="startDate"
              label="Start Date"
              style={{width: "100%"}}
              minDate={initialDate}
              maxDate={maxDate}
              defaultValue={initialDate}
              disableToolbar={true}
              autoOk={true}
              format={dateFormat}
            />
          </Grid>
          <Grid item xs={2} checkChildren={true}>
            {(record) => (
              <DatePicker
                id="endDate"
                label="End Date"
                style={{width: "100%"}}
                minDate={record.startDate}
                maxDate={maxDate}
                defaultValue={record.startDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
              />
            )}
          </Grid>
          <Grid item xs={2} checkChildren={true}>
          {(record) => (
            <ComboSelect
              id="frequencyType"
              label="Frequency"
              defaultValue={"1"}
              group="FREQUENCY TYPES"
              subGroup=""
              readOnly={record.recordType==="OVERRIDE"}
              disabled={record.recordType==="OVERRIDE"}
              //style={{marginTop:2}}
            />
          )}
          </Grid>
          <Grid item xs={2} checkChildren={true}>
          {(record) => (
            <ComboSelect
              id="dow"
              label="Day"
              defaultValue={"1"}
              group="DAY OF WEEK"
              subGroup=""
              readOnly={record.recordType==="OVERRIDE"}
              disabled={record.recordType==="OVERRIDE"}
              //style={{marginTop:2}}
            />
          )}
          </Grid>
          {props.source !== "FLIGHT PLANNING"
            ?
              <Fragment checkChildren={true}>
                <Grid item xs={2} checkChildren={true} style={{marginTop: 1}}>
                  {record => (
                      <FormSelect
                        id="commercialOwnerId"
                        label="Account Manager"
                        options={userOptions}
                        readOnly={false}
                        value={record.commercialOwnerId}
                        onChange={(value, props) => {
                          props.onChange(value);
                        }}
                        style={{width: 200}}
                      />
                    )
                  }
                </Grid>
                <Grid item xs={2} checkChildren={true}>
                  <MaskedText
                    id="uniqueCostingNo"
                    label="Costing Number"
                    style={{width: "100%"}}
                    mask="UUU-9999999"
                    maskChar={""}
                    alwaysShowMask={false}
                    formatChars={formatChars}
                    forceUpperCase={true}
                    defaultValue=""
                    inputLabelProps={{shrink: true}}
                  />
                </Grid>
              </Fragment>
            :
              <Grid item xs={2} checkChildren={true}>
                {(record, changeRecord) => {
                  if (record.uniqueCostingNo) return (
                    <ContextMenu
                      menuItems={[
                        {code: "EDIT", label: "Edit Costing", icon: <MonetizationOn/>, action: ()=>{editCosting(record)}},
                        {code: "VIEW", label: "View Costing", icon: <Preview/>, action: ()=>{viewCosting(record)}},
                      ]}
                    >
                      <Text
                        id="uniqueCostingNo"
                        label="Costing Number"
                        style={{width: "100%"}}
                        mask="UUU-9999999"
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                        forceUpperCase={true}
                        defaultValue=""
                        inputLabelProps={{shrink: true}}
                        onClick={() => {
                          viewCosting(record);
                        }}
                      />
                    </ContextMenu>
                  )
                  return (
                    <Text
                      id="uniqueCostingNo"
                      label="Costing Number"
                      style={{width: "100%"}}
                      mask="UUU-9999999"
                      maskChar={""}
                      alwaysShowMask={false}
                      formatChars={formatChars}
                      forceUpperCase={true}
                      defaultValue=""
                      inputLabelProps={{shrink: true}}
                    />
                  )
                }}
              </Grid>
          }
          <Grid item xs={6} checkChildren={true}>
            <AircraftMultiSelect
              id="initialAircraft"
              label="Initial Aircraft"
              style={{width: "100%"}}
            />
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            <AircraftMultiSelect
              id="aircraftRotation"
              label="Aircraft Rotation"
              style={{width: "100%"}}
            />
          </Grid>

          <Grid item xs={4} checkChildren={true}>
            <div className="d-flex flex-row justify-content-between align-items-center">
              <label htmlFor="primaryRoute" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                Route
              </label>
            </div>
            <div id="primaryRoute" style={{paddingTop: 6}}>
              {(rowData) => (<BuildPrimaryRouteFromLegs legs={rowData.legs}/>)}
            </div>
          </Grid>
          <Grid item xs={4} checkChildren={true}>
            <div className="d-flex flex-row justify-content-between align-items-center">
              <label htmlFor="onwardRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                Onward Routes
              </label>
            </div>
            <div id="onwardRoutes" style={{paddingTop: 6}}>
              {(rowData) => (<BuildOnwardRoutesFromLegs legs={rowData.legs}/>)}
            </div>
          </Grid>
          <Grid item xs={4} checkChildren={true}>
          <div className="d-flex flex-row justify-content-between align-items-center">
              <label htmlFor="truckRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                Trucking
              </label>
            </div>
            <div id="truckRoutes" style={{paddingTop: 6}}>
              {(rowData) => (<BuildTruckRoutesFromLegs legs={rowData.legs}/>)}
            </div>
          </Grid>
          <Grid item xs={12} checkChildren={true}>
            <ScheduledTripLegEditor
              tripRecord={dialogStates.record}
              handleUpdate={handleUpdate}
              extraKeys={extraKeys}
              canEdit={true}
              classes={classes}
              onChange={handleLegsChanged}
            />
          </Grid>
        </Grid>
        {(rowData, changeRecord, changeButtonState) => {
          return (
            <AddCostingDialog
              SystemData={SystemData}
              extraKeys={extraKeys}
              apiSitePrefix={apiSitePrefix}
              defaultValues={costingDefaultValues}
              classes={costingClasses}
              handleAdd={handleAddCosting}
              source={props.source}
              afterSave={(savedCosting)=>{
                if (props.source === 'FLIGHT PLANNING') {
                  if (savedCosting?.costingNumber) {
                    changeRecord({uniqueCostingNo: `UCN-${savedCosting.costingNumber}`});
                  }
                  // queryClient.invalidateQueries(['Trips']);
                  // setDialogStates({...dialogStates, showDialog: false, record: null});  
                } else {
                  queryClient.invalidateQueries(['ScheduledTripTree']);
                  setDialogStates({...dialogStates, showDialog: false, record: null, originalRecord: null, childRecords: null, parentRecord: null});  
                }
              }}
            />
          )
        }}
        {(rowData, changeRecord, changeButtonState) => {
          return (
            <EditCostingDialog
              SystemData={SystemData}
              extraKeys={extraKeys}
              apiSitePrefix={apiSitePrefix}
              defaultValues={costingDefaultValues}
              classes={costingClasses}
              handleUpdate={handleUpdateCosting}
              source={props.source}
              afterSave={(savedCosting)=>{
                if (props.source === 'FLIGHT PLANNING') {
                  changeRecord({uniqueCostingNo: `UCN-${savedCosting.costingNumber}`});
                  // queryClient.invalidateQueries(['Trips']);
                  // setDialogStates({...dialogStates, showDialog: false, record: null});  
                } else {
                  queryClient.invalidateQueries(['ScheduledTripTree']);
                  setDialogStates({...dialogStates, showDialog: false, record: null, originalRecord: null, childRecords: null, parentRecord: null});  
                }
              }}
            />
          )
        }}
        {(rowData, changeRecord, changeButtonState) => {
          return (
            <ViewCostingDialog
              SystemData={SystemData}
              extraKeys={extraKeys}
              apiSitePrefix={apiSitePrefix}
              defaultValues={costingDefaultValues}
              classes={costingClasses}
              source={props.source}
            />
          )
        }}  
      </FormDialog>
    )
  }
  return (<></>);
}

export default EditScheduledTripDialog;
